import { useState, useEffect } from 'react';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import Select from 'react-select';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import Navbar from '../Navbar';
import Header from '../Header';
import baseUrl from '../BaseUrl';
import Loader from '../Loader';

const ImportTN = () => {
    const [name,   setName]   = useState('');
    const [token,  setToken]  = useState('');
    const [expire, setExpire] = useState('');
    const [role,   setRole]   = useState('');
    const [access, setAccess] = useState([]);
    const [user,   setUser]   = useState(null);
    const [popupOpen, setPopupOpen] = useState(false);
    const [msg, setMsg] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const [companies,   setCompanies]   = useState([]);
    const [selectedCid, setSelectedCid] = useState(location.state?.cid || '');
    const [allDetails,  setAllDetails]  = useState([]);
    const [allLanguages,setAllLanguages]= useState([]);

    const [importType,    setImportType]    = useState('tn'); // 'tn' | 'tag' | 'all'
    const [selectedDetails, setSelectedDetails] = useState('');
    const [selectedLang,    setSelectedLang]    = useState('');
    const [file,            setFile]            = useState(null);
    const [errors,          setErrors]          = useState({});
    const [allRiskTypes, setAllRiskTypes] = useState([]);
    const [hasRisk,      setHasRisk]      = useState('');
    const [riskTypeIds,  setRiskTypeIds]  = useState([]); // react-select options (multi)
    const [callPassActive, setCallPassActive] = useState('');
    const [result,          setResult]          = useState(null);

    useEffect(() => { refreshToken(); getUserAccess(); }, []);
    useEffect(() => { if (role > 2) navigate('/dashboard'); }, [role]);
    useEffect(() => {
        if (user !== null && role !== '' && parseInt(role) > 1 && !user.hasEdit) navigate('/dashboard');
    }, [user, role]);
    useEffect(() => { if (token && user !== null) { loadCompanies(); loadRiskTypes(); } }, [token, user]);
    useEffect(() => { if (token && user !== null && selectedCid) { loadDetails(); loadLanguages(); } }, [token, user, selectedCid]);

    const refreshToken = async () => {
        try {
            const res = await axios.get(`${baseUrl}/token`);
            setToken(res.data.accessToken);
            const decoded = jwt_decode(res.data.accessToken);
            setName(decoded.name); setRole(decoded.role); setExpire(decoded.exp);
        } catch { navigate('/'); window.location.reload(); }
    };
    const getUserAccess = async () => {
        try {
            const res = await axiosJWT.get(`${baseUrl}/user-access`, { headers: { Authorization: `Bearer ${token}` } });
            setAccess(res.data.results);
            setUser({ hasEdit: !!res.data.enrms_registration_edit_switch });
        } catch (e) { navigate('/dashboard'); }
    };

    const axiosJWT = axios.create();
    axiosJWT.interceptors.request.use(async (config) => {
        if (expire * 1000 < Date.now()) {
            const res = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${res.data.accessToken}`;
            setToken(res.data.accessToken);
            const decoded = jwt_decode(res.data.accessToken);
            setName(decoded.name); setExpire(decoded.exp);
        }
        return config;
    }, err => Promise.reject(err));

    const loadCompanies = async () => {
        try {
            const res = await axiosJWT.get(`${baseUrl}/registration/setup/company-list`, { headers: { Authorization: `Bearer ${token}` } });
            setCompanies(res.data.data);
        } catch (e) { console.log(e); }
    };
    const loadDetails = async () => {
        try {
            const res = await axiosJWT.get(`${baseUrl}/registration/setup/details/all?cid=${selectedCid}`, { headers: { Authorization: `Bearer ${token}` } });
            setAllDetails(res.data.data);
        } catch (e) { console.log(e); }
    };
    const loadLanguages = async () => {
        try {
            const res = await axiosJWT.get(`${baseUrl}/registration/setup/language/all?cid=${selectedCid}`, { headers: { Authorization: `Bearer ${token}` } });
            setAllLanguages(res.data.data);
        } catch (e) { console.log(e); }
    };
    const loadRiskTypes = async () => {
        try {
            const res = await axiosJWT.get(`${baseUrl}/registration/admin/risk-types/all`, { headers: { Authorization: `Bearer ${token}` } });
            setAllRiskTypes(res.data.data);
        } catch (e) { console.log(e); }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const errs = {};
        if (!selectedCid)       errs.cid     = 'Customer required.';
        if (!selectedDetails)   errs.details = 'Registration Details required.';
        if (!selectedLang)      errs.lang    = 'Registration Language required.';
        if (importType !== 'all' && !file) errs.file = 'File required for TN/Tag import.';
        setErrors(errs);
        if (Object.keys(errs).length > 0) return;

        try {
            setPopupOpen(true);
            setResult(null);
            const formData = new FormData();
            formData.append('cid', selectedCid);
            formData.append('reg_details_id', selectedDetails);
            formData.append('reg_lang_id', selectedLang);
            formData.append('import_type', importType);
            if (file) formData.append('file', file);
            if (hasRisk !== '') formData.append('has_risk', hasRisk);
            if (riskTypeIds.length > 0) formData.append('registration_risk_type_id', riskTypeIds.map(o => o.value).join(','));
            if (callPassActive !== '') formData.append('call_pass_active', callPassActive);

            const res = await axiosJWT.post(`${baseUrl}/registration/setup/import`, formData, {
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
            });
            setIsSuccess(true);
            if (res.data.processing) {
                setMsg('We are processing your import request. You can check the import log in the Import History page.');
            } else {
                setMsg(res.data.msg);
                setResult(res.data);
            }
        } catch (e) {
            setIsSuccess(false);
            setMsg(e.response?.data?.msg || 'Import failed.');
        }
        setPopupOpen(false);
    };

    return (
        <div className="panelbox">
            <Navbar token={token} access={access} />
            <div className="right-panel">
                <Header name={name} />
                {(user === null || popupOpen) && <Loader />}
                <div className="content-page admin-attendance-page">
                    <div className="row">
                        <div className="col-6"><div className="left-title"><h1>Import TN / Tag Registration</h1></div></div>
                        <div className="col-6 inventory-btn">
                            <div className="addnew-button" style={{ display:'flex', gap:'10px', alignItems:'center' }}>
                                <Link to="/enrms-registration-import-history" state={{ cid: selectedCid }} className="btn btn-outline-secondary btn-sm">History</Link>
                                <Link to="/enrms-registration-setup" state={{ cid: selectedCid }}><span>&larr;</span> Back</Link>
                            </div>
                        </div>
                    </div>

                    <p className={`has-text-centered ${isSuccess ? 'success' : 'error'}`}>{msg}</p>

                    <div className="row">
                        <div className="col-12 common-white-shadow-background setting-section">
                            <form onSubmit={handleSubmit}>
                                {/* Step 1: Customer */}
                                <div className="row" style={{ marginBottom:'15px' }}>
                                    <div className="col-md-4">
                                        <label><strong>Step 1:</strong> Select Customer *</label>
                                        <select className="form-control" value={selectedCid} onChange={e => { setSelectedCid(e.target.value); setSelectedDetails(''); setSelectedLang(''); setFile(null); setErrors({}); setResult(null); setMsg(''); setHasRisk(''); setRiskTypeIds([]); setCallPassActive(''); }}>
                                            <option value="">— Select Customer —</option>
                                            {companies.map(c => <option key={c.id} value={c.id}>{c.cname}</option>)}
                                        </select>
                                        {errors.cid && <div className="error error-message">{errors.cid}</div>}
                                    </div>
                                </div>

                                {selectedCid && (
                                    <>
                                        {/* Step 2: Registration Details */}
                                        <div className="row" style={{ marginBottom:'15px' }}>
                                            <div className="col-md-4">
                                                <label><strong>Step 2:</strong> Select Registration Details *</label>
                                                <select className="form-control" value={selectedDetails} onChange={e => setSelectedDetails(e.target.value)}>
                                                    <option value="">— Select —</option>
                                                    {allDetails.map(d => <option key={d.reg_details_id} value={d.reg_details_id}>{d.registration_short_description}</option>)}
                                                </select>
                                                {errors.details && <div className="error error-message">{errors.details}</div>}
                                            </div>
                                        </div>

                                        {/* Step 3: Registration Language */}
                                        <div className="row" style={{ marginBottom:'15px' }}>
                                            <div className="col-md-4">
                                                <label><strong>Step 3:</strong> Select Registration Language *</label>
                                                <select className="form-control" value={selectedLang} onChange={e => setSelectedLang(e.target.value)}>
                                                    <option value="">— Select —</option>
                                                    {allLanguages.map(l => <option key={l.reg_lang_id} value={l.reg_lang_id}>{l.short_description}</option>)}
                                                </select>
                                                {errors.lang && <div className="error error-message">{errors.lang}</div>}
                                            </div>
                                        </div>

                                        {/* Step 4: Has Risk + Risk Type */}
                                        <div className="row" style={{ marginBottom:'15px' }}>
                                            <div className="col-md-3">
                                                <label><strong>Step 4:</strong> Has Risk (optional)</label>
                                                <select className="form-control" value={hasRisk} onChange={e => { setHasRisk(e.target.value); if (e.target.value !== '') setRiskTypeIds([]); }}>
                                                    <option value="">— Default —</option>
                                                    <option value="0">0 — No Risk</option>
                                                    <option value="1">1 — Has Risk</option>
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label>Risk Type (optional, leave blank if Has Risk is set)</label>
                                                <Select
                                                    isMulti
                                                    placeholder="— None —"
                                                    value={riskTypeIds}
                                                    onChange={selected => { setRiskTypeIds(selected || []); if (selected && selected.length > 0) setHasRisk(''); }}
                                                    options={allRiskTypes.map(r => ({
                                                        value: r.registration_risk_type_id,
                                                        label: `${r.risk_data_source} — ${r.registration_risk_value}${r.registration_website_description ? ` (${r.registration_website_description})` : ''}`
                                                    }))}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label>Call Pass Active</label>
                                                <select className="form-control" value={callPassActive} onChange={e => setCallPassActive(e.target.value)}>
                                                    <option value="">— Any —</option>
                                                    <option value="1">Active</option>
                                                    <option value="0">Not Active</option>
                                                </select>
                                                <small style={{ color:'#666' }}>Applied to every row in the uploaded file.</small>
                                            </div>
                                        </div>

                                        {/* Step 5: What to import */}
                                        <div className="row" style={{ marginBottom:'15px' }}>
                                            <div className="col-md-6">
                                                <label><strong>Step 5:</strong> What to import</label>
                                                <div>
                                                    <label style={{ marginRight:'20px' }}>
                                                        <input type="radio" style={{ width:'auto' }} value="tn" checked={importType === 'tn'} onChange={() => { setImportType('tn'); setFile(null); setErrors({}); setMsg(''); }} /> Upload TN file
                                                    </label>
                                                    <label style={{ marginRight:'20px' }}>
                                                        <input type="radio" style={{ width:'auto' }} value="tag" checked={importType === 'tag'} onChange={() => { setImportType('tag'); setFile(null); setErrors({}); setMsg(''); }} /> Upload Tag file
                                                    </label>
                                                    <label>
                                                        <input type="radio" style={{ width:'auto' }} value="all" checked={importType === 'all'} onChange={() => { setImportType('all'); setFile(null); setErrors({}); setMsg(''); }} /> All TN / All Tags (no file)
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Step 6: File Upload */}
                                        {importType !== 'all' && (
                                            <div className="row" style={{ marginBottom:'15px' }}>
                                                <div className="col-md-5">
                                                    <label><strong>Step 6:</strong> Upload file (XLSX or CSV) — first column must be <strong>{importType === 'tn' ? 'TN' : 'Tag'}</strong>. Submissions must be in the format of this template.</label>
                                                    <div className="download-templte" style={{ marginBottom:'8px' }}>
                                                        <a className="newrow" target="_blank"
                                                            href={`${process.env.PUBLIC_URL}/template/${importType === 'tn' ? 'Registration_TN_Import_Template.xlsx' : 'Registration_Tag_Import_Template.xlsx'}`}
                                                            download={importType === 'tn' ? 'Registration_TN_Import_Template.xlsx' : 'Registration_Tag_Import_Template.xlsx'}>
                                                            Download Template
                                                        </a>
                                                        <p>Submissions must be in the format of this template</p>
                                                    </div>
                                                    <input key={importType} type="file" className="form-control" accept=".xlsx,.csv,.xls" onChange={e => setFile(e.target.files[0])} />
                                                    {errors.file && <div className="error error-message">{errors.file}</div>}
                                                </div>
                                            </div>
                                        )}

                                        <div className="row">
                                            <div className="col-12">
                                                <button type="submit" className="btn btn-primary">Import</button>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </form>

                            {/* Import Result */}
                            {result && (
                                <div style={{ marginTop:'20px' }}>
                                    <h5>Import Result</h5>
                                    <p><strong>Inserted:</strong> {result.inserted}</p>
                                    {result.errors && result.errors.length > 0 && (
                                        <div>
                                            <strong>Errors ({result.errors.length}):</strong>
                                            <div style={{ maxHeight:'200px', overflowY:'auto', border:'1px solid #ddd', padding:'10px', marginTop:'5px' }}>
                                                {result.errors.map((err, i) => (
                                                    <div key={i} style={{ color:'#c00' }}>{err.value}: {err.error}</div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImportTN;
